import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';

import { Navigate, RouteProps, useLocation } from 'react-router-dom';

import { AuthContext } from '../../utils/AuthProvider';

export enum Mode {
  Participant = 'PARTICIPANT',
  Facilitator = 'FACILITATOR',
}

export const ModeContext = createContext<[Mode, Dispatch<SetStateAction<Mode>>]>([Mode.Participant, () => {}]);

export default function ProtectedRoute(props: RouteProps) {
  const { children } = props;
  const contextValue = useState<Mode>(Mode.Participant);

  const { user } = useContext(AuthContext)!;
  const { pathname } = useLocation();

  if (!children) return null;
  return user ? (
    <ModeContext.Provider value={contextValue}>{children}</ModeContext.Provider>
  ) : (
    <Navigate
      to={{
        pathname: '/register',
        search: `?redirectTo=${pathname}`,
      }}
      replace={true}
    />
  );
}
